// extracted by mini-css-extract-plugin
export var component = "Alert-module--component--wCx6k";
export var icon = "Alert-module--icon--oh7ti";
export var error = "Alert-module--error--M2l-0";
export var warning = "Alert-module--warning--5TAV2";
export var info = "Alert-module--info--UuKJ6";
export var success = "Alert-module--success--ZKaLH";
export var textError = "Alert-module--textError--S2Vsv";
export var textWarning = "Alert-module--textWarning--2pdBM";
export var textInfo = "Alert-module--textInfo--xm1Ku";
export var textSuccess = "Alert-module--textSuccess--+6g0O";